import SimpleBar from 'simplebar';


const iImgFrame = () => {
    const el = document.querySelector('.js-imgFrame');
    if (!el) return;
    new SimpleBar(el, { autoHide: false, forceVisible: 'x' });
};

export default iImgFrame;